import { render, staticRenderFns } from "./PatientContactMethodsDisplay.vue?vue&type=template&id=c8f47bdc"
import script from "./PatientContactMethodsDisplay.vue?vue&type=script&lang=js"
export * from "./PatientContactMethodsDisplay.vue?vue&type=script&lang=js"
import style0 from "./PatientContactMethodsDisplay.vue?vue&type=style&index=0&id=c8f47bdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports